import { render, staticRenderFns } from "./JdsTableSegment.vue?vue&type=template&id=53cabb4e&scoped=true&"
import script from "./JdsTableSegment.vue?vue&type=script&lang=ts&"
export * from "./JdsTableSegment.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTableSegment.vue?vue&type=style&index=0&id=53cabb4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cabb4e",
  null
  
)

export default component.exports